<template>
  <div class="service-page">
    <top-bar :topbarList="serviceTopBarList"></top-bar>
    <router-view></router-view>
  </div>
</template>

<script>
import topBar from "@/components/topBar.vue";

import { serviceIndexMixins } from "@/mixins/serviceIndexMixins";

export default {
  mixins: [serviceIndexMixins],
  data() {
    return {};
  },
  computed: {},
  components: {
    topBar,
  },
};
</script>

<style lang="less" scoped>
.service-page {
  height: 100%;
}
</style>
